import React from 'react';
import Button from '@dashboard/components/Button';
import Reorderable from '@dashboard/components/Reorderable';
import { Accordion } from '@dashboard/components/ui/accordion';
import { useFeeEdit } from './FeeEditContext';
import { feeId } from './feeFormValues';
import { useFees } from './FeesContext';
import FeeItem from './FeeItem';

export default function FeesList() {
  const { state: fees } = useFees();
  const { isAddingFee, onReorderFees, onAddFee, setIsEditingFee } = useFeeEdit();

  const openFee = fees.find(fee => fee.isEditing);
  const openValue = openFee ? feeId(openFee) : '';

  const handleValueChange = value => {
    if (value) {
      setIsEditingFee(true, value);
    } else if (openFee) {
      setIsEditingFee(false, feeId(openFee));
    }
  };

  return (
    <div>
      {fees.length > 0 && (
        <div className="mb-4">
          <Accordion
            type="single"
            collapsible
            value={openValue}
            onValueChange={handleValueChange}
            className="border-t"
          >
            <Reorderable.Wrapper>
              <Reorderable
                id="fees"
                items={fees}
                onReorder={onReorderFees}
                renderItem={({ item: fee, dragHandleProps, isDragging }) => (
                  <Reorderable.Item isDragging={isDragging}>
                    <FeeItem fee={fee} dragHandleProps={dragHandleProps} />
                  </Reorderable.Item>
                )}
              />
            </Reorderable.Wrapper>
          </Accordion>
        </div>
      )}

      {!isAddingFee && !openFee && (
        <div className="flex">
          <Button handleClick={onAddFee} appearance="primary">
            + Add fee
          </Button>
        </div>
      )}
    </div>
  );
}
